'use client';

import React, { useState } from 'react';

import { MenuIcon } from '@depop/web-ui-kit/Icons/MenuIcon';
import { useTranslations } from 'next-intl';

import { MobileNavigationMenu } from './MobileNavigationMenu';
import styles from './styles.module.css';

import { SecondaryNav } from '@/components/MobileNavigation/SecondaryNav';
import { useAuth } from '@/modules/auth/useAuth';
import { useConsentManager } from '@/modules/consent/hooks/useConsentManager';
import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

export function MobileNavigation() {
  const t = useTranslations('common');
  const [isOpen, setIsOpen] = useState(false);

  const { logout } = useAuth();
  const { transcend } = useConsentManager();

  const [{ web_8685_app_download_burger_menu }, bucketFn] = useExperiments(
    ['web_8685_app_download_burger_menu'],
    { deferred: true }
  );

  const showAppDownloadExperiment =
    web_8685_app_download_burger_menu === VARIANT_IDENTIFIER;

  function handleCookiesClick() {
    transcend?.showConsentManager();
    setIsOpen(false);
  }

  function confirmLogout(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    logout(e);
    // Ensure mobile menu is closed when log out is called
    setIsOpen(false);
  }

  return (
    <div className={styles.wrapper}>
      <button
        className={styles.triggerButton}
        onClick={() => {
          setIsOpen(true);
          bucketFn();
        }}
        aria-label="Open menu"
        // eslint-disable-next-line no-restricted-syntax
        data-testid="mobileNavigation"
        aria-haspopup="dialog"
      >
        <MenuIcon
          aria-hidden
          className={styles.triggerIcon}
          title={t('Nav.Menu')}
        />
      </button>
      <MobileNavigationMenu
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        handleLogout={confirmLogout}
        secondaryNav={<SecondaryNav onCookiesClick={handleCookiesClick} />}
        showAppDownloadExperiment={showAppDownloadExperiment}
      />
    </div>
  );
}
